export default ({ Vue, app }) => {
  Vue.filter('address', (address) => {
    return `${address.street}, ${address.city}, ${address.country}, ${address.state} ${address.zip}`;
  });
};
